export default __webpack_public_path__ + "static/media/upwork.f4066c41.png";